"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxSearchCalendarLegacyArgs = void 0;
var HxTimeRange_1 = require("./HxTimeRange");
function serializeHxSearchCalendarLegacyArgs(_arg) {
    var output = [];
    output.push(_arg.requestId);
    output.push(_arg.searchQuery);
    output.push(_arg.maxResultsRequested);
    output.push(_arg.isMultiAccountRequest !== undefined);
    if (_arg.isMultiAccountRequest !== undefined) {
        output.push(_arg.isMultiAccountRequest);
    }
    output.push(_arg.isWordWheeled);
    output.push(_arg.sortDirection !== undefined);
    if (_arg.sortDirection !== undefined) {
        output.push(_arg.sortDirection);
    }
    output.push(_arg.timeRange !== undefined);
    if (_arg.timeRange !== undefined) {
        output.push(HxTimeRange_1.serializeHxTimeRange(_arg.timeRange));
    }
    var calendarsToSearchOutput = [];
    _arg.calendarsToSearch.forEach(function (item) { return calendarsToSearchOutput.push(item); });
    output.push(calendarsToSearchOutput);
    output.push(_arg.logicalId);
    output.push(_arg.substrateScenarioName);
    output.push(_arg.substrateDebugSetting);
    output.push(_arg.substrateFlightsControlledByClient);
    output.push(_arg.requestIssuedTime.valueOf());
    return output;
}
exports.serializeHxSearchCalendarLegacyArgs = serializeHxSearchCalendarLegacyArgs;
